import React from 'react';

export default function NumberField({
  value,
  onChange,
  min,
  max,
}) {
  const buttonClick = (amount) => {
    const newValue = value + amount;

    if (newValue < min) return;
    if (newValue > max) return;

    onChange(newValue);
  };

  return (
    <div className="fz-border fz-border-solid fz-self-start fz-flex fz-border-gray-400">
      <button
        className="fz-bg-transparent fz-border-0 fz-text-base"
        onClick={() => { buttonClick(-1); }}
        type="button"
      >
        −
      </button>
      <span className="fz-border-y-0 fz-border-x fz-w-12 fz-text-center fz-text-base fz-border-solid fz-border-gray-400">
        {value}
      </span>
      <button
        className="fz-bg-transparent fz-border-0 fz-text-base"
        onClick={() => { buttonClick(1); }}
        type="button"
      >
        ＋
      </button>
    </div>
  );
}
